import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 1023px) {  
  }
  @media (max-width: 600px) {
    flex-direction: column;
  } 
  @media (max-width: 480px) {
  }
`;

const StepBox = styled.div`
  width: 185px;
  height: 150px;
  position: relative;
  background: url(${props => props.imageUrl}) no-repeat center 30%;
  background-size: 40%;
  border-radius: 12px;
  background-color: rgb(255, 255, 255);
  box-shadow: 0px 10px 35px 0px rgba(0, 0, 0, 0.1);
  
  @media (max-width: 1023px) {
  }
  @media (max-width: 800px) {
    width: 150px;
    height: 120px;
    background-position: center 25%;
  } 
  @media (max-width: 480px) {
  }
`;
const StepNumber = styled.div`
  position: absolute;
  top: -10px;
  left: -10px;
  width: 25px;
  height: 25px;
  background-color: #0F62BD;
  border-radius: 12.5px;
  color: #FFF;
  font-weight: 500;
  font-size: 0.7rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StepText = styled.div`
  margin-top: 58%;
  text-align: center;
  font-size: 0.7rem;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2em;
  
  @media (max-width: 800px) {
    margin-right: 1em;
    margin-left: 1em;
  } 
`;

const Separator = styled.div`
  width: 96px;
  margin: 6px;
  text-align: center;
  border-top: 3px dashed #D7D7D7;
  height: 0;

  @media (max-width: 1023px) {
    width: 40px;
  }  
  @media (max-width: 600px) {
    height: 20px
    width: 0;
    border-left: 3px dashed #D7D7D7;
    border-top: 0;
  }
`;

const HowItWorksSteps = (props) =>
  (<Container>
    <StepBox imageUrl="/recipient.png">
      <StepNumber>1</StepNumber>
      <StepText>Provide the recipient's email</StepText>
    </StepBox>
    <Separator />
    <StepBox imageUrl="/piggiebank.png">
      <StepNumber>2</StepNumber>
      <StepText>Fund the gift</StepText>
    </StepBox>
    <Separator />
    <StepBox imageUrl="/happy.png">
      <StepNumber>3</StepNumber>
      <StepText>We email the gift!</StepText>
    </StepBox>
  </Container>);

export default HowItWorksSteps;


// WEBPACK FOOTER //
// ./src/Containers/HowItWorksSteps.js